module.exports = __webpack_public_path__ + "img/large_logo.7139738d.png";